import { render, staticRenderFns } from "./PlaceOrderPro2.vue?vue&type=template&id=8d3efc1e&scoped=true&"
import script from "./PlaceOrderPro2.vue?vue&type=script&lang=js&"
export * from "./PlaceOrderPro2.vue?vue&type=script&lang=js&"
import style0 from "./PlaceOrderPro2.vue?vue&type=style&index=0&id=8d3efc1e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d3efc1e",
  null
  
)

export default component.exports